export default "__VITE_ASSET__e935a17b__"